import * as React from 'react';
import { SVGProps } from 'react';

const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.532 15.876 11.202 3.68A1.39 1.39 0 0 0 10 3a1.39 1.39 0 0 0-1.2.68L1.466 15.875A1.404 1.404 0 0 0 2.67 18h14.663a1.403 1.403 0 0 0 1.2-2.124Zm-7.699-.376H9.167v-1.667h1.666V15.5Zm0-3.333H9.167V8h1.666v4.167Z"
      fill="#FF5252"
    />
  </svg>
);

export default SvgAlert;
